import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import type { IBetSlipCashOut } from '@/interface/IBetSlipCashOut';
import { SportType } from '@/interface/enum';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { useRootStore } from '@/stores/rootStore';

function isCashOutBlockedMarket(bet: IBetSlipCashOut, notSupportedMarketTypes: number[]) {
    return !bet.leagueId || notSupportedMarketTypes.includes(bet.marketType);
}

export function useSingleBetCashOut(bet: Ref<IBetSlipCashOut>) {
    const {
        cashOutSupportedMarkets,
        cashOutNotSupportMarketType,
        isCashOutEnabled,
        isCashOutPageEnabled,
    } = storeToRefs(useFeatureToggleStore());
    const { isCashOutTooltipShowOnce, hasSeenCashOutTutorial } = storeToRefs(useRootStore());

    const isDisplayCashOutIcon = computed(() => {
        if (isCashOutBlockedMarket(bet.value, cashOutNotSupportMarketType.value)) {
            return false;
        }

        return isCashOutEnabled.value && isSupportSportMarket(bet.value);
    });

    function isSupportSportMarket({ sportType, isMainMarket, isLive }: IBetSlipCashOut) {
        if (cashOutSupportedMarkets.value[0] === '*') {
            return true;
        }

        // / 01 is 0 or 1 all can use, * is all open
        const supportMarket = new RegExp(`{(${sportType}|\\*):[${isMainMarket ? '01' : '1'}]:[${isLive ? 1 : 0}*]:[01]}`);
        return cashOutSupportedMarkets.value.filter(x => supportMarket.exec(x)).length > 0;
    }

    const isDisplayCashOutTooltip = computed(() => isDisplayCashOutIcon.value
        && isCashOutPageEnabled.value
        && !isCashOutTooltipShowOnce.value
        && !hasSeenCashOutTutorial.value);

    return {
        isDisplayCashOutIcon,
        isDisplayCashOutTooltip,
    };
}

export function useParlayCashOut(subBets: Ref<IBetSlipCashOut[]>) {
    const { cashOutNotSupportMarketType, isMpCashOutEnabled } = storeToRefs(useFeatureToggleStore());

    const isDisplayCashOutIcon = computed(() => (
        isMpCashOutEnabled.value
        && subBets.value.length > 0
        && subBets.value.every(subBet => (
            !isCashOutBlockedMarket(subBet, cashOutNotSupportMarketType.value)
            && subBet.sportType === SportType.Soccer
        ))
    ));

    return { isDisplayCashOutIcon };
}
